<template>
  <v-dialog persistent v-model="dialogIsActive" max-width="500">
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-bind="attrs"
        v-on="on"
        color="primary"
        rounded
        small
      >
        <v-icon left>mdi-plus</v-icon>
        Ajouter un établissement
      </v-btn>
    </template>

    <v-card>
      <v-card-title>Ajout d'un établissement</v-card-title>

      <v-card-text @submit.prevent>
        <v-form ref="form">
          <v-text-field
            label="Nom de l'établissement"
            v-model="establishment.name"
            :rules="rules.name"
            validate-on-blur
            filled
          ></v-text-field>

          <v-text-field
            v-if="jobType === 'ADM'"
            label="Nature de la charge exercée"
            v-model="establishment.charge"
            :rules="rules.charge"
            validate-on-blur
            filled
          ></v-text-field>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-btn text @click="close">Annuler</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="addEstablishment">Ajouter</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'EstablishmentForm',

  props: {
    jobType: String,
  },

  data: () => ({
    dialogIsActive: false,
    rules: {
      name: [(v) => !!v || 'Ce champs est obligatoire'],
      charge: [(v) => !!v || 'Ce champs est obligatoire'],
    },
    establishment: {
      name: '',
      charge: '',
    },
  }),

  methods: {
    addEstablishment() {
      if (!this.$refs.form.validate()) return;
      this.$emit('adding-establishment', this.establishment);
      this.close();
    },
    close() {
      this.$refs.form.reset();
      this.dialogIsActive = false;
    },
  },
};
</script>
